import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { handleError } from './common';

/*
	Actions
 */
function initUnlockAction(data) {
	return {
		type: 'INIT_UNLOCK',
		data: data
	}
}

function unlockVerifyAction(data) {
	return {
		type: 'UNLOCK_VERIFY',
		data: data
	}
}

function unlockChangePasswordAction(data) {
	return {
		type: 'UNLOCK_CHANGE_PASSWORD',
		data: data
	}
}

/*
	Async Actions
 */
export function initUnlock() {
	return dispatch => {
		fetch('/api/account/unlock/init', {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitUnlock(dispatch, data))
	}
}

export function unlockVerify(code, tool) {
	return (dispatch, getState) => {
		const state = getState();
		const { gateway } = state.verification;
		fetch('/api/account/unlock/verify', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				code: code,
				tool: tool,
				gateway: gateway,
			})
		})
			.then(response => response.json())
			.then(data => handleUnlockVerify(dispatch, data))
	}
}

export function unlockChangePassword(password, newPassword) {
	return dispatch => {
		fetch('/api/account/unlock/change_password', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				password: password,
				new_password: newPassword
			})
		})
			.then(response => response.json())
			.then(data => handleUnlockChangePassword(dispatch, data))
	}
}

/*
	Helper functions
 */
function handleInitUnlock(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(initUnlockAction(data));
	if (data.next_action.action_type === ACTION_TYPE.UNLOCK_VERIFY) {
		browserHistory.push('/unlock/verify');
	}
}

function handleUnlockVerify(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(unlockVerifyAction(data));
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.UNLOCK_CHANGE_PASSWORD) {
		browserHistory.push('/unlock/change_password');
	}
}

function handleUnlockChangePassword(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(unlockChangePasswordAction(data));
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.DONE) {
		browserHistory.push('/unlock/done');
	}
}


// WEBPACK FOOTER //
// ./app/actions/unlock.js